import styled from 'styled-components';

export const RoomInfoMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l20};
    `
);

export const RoomInfoInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-top: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        border-radius: ${props.theme.misc.borderRadius.base};
    `
);

export const RoomInnerBlock = styled.div(
    props => `
        width:40%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l15};
        background-color: ${props.theme.colors.grey.lightf9};
        border-radius: ${props.theme.misc.borderRadius.base} 0 0 ${props.theme.misc.borderRadius.base};
        box-shadow: 1px 0 5px -1px rgba(74, 74, 74, 0.15);
        position: relative;
    `
);

export const RoomTypeInfoWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
    `
);

export const RoomInfoWrap = styled.div(
    props => `
        width:75%;
        display: flex;
        flex-direction: column;
    `
);

export const DifferentRoomWrap = styled.div(
    props => `
        display: flex;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.large.l13} ${props.theme.spacing.base} ${props.theme.spacing.large.l40};
        position: absolute;
        left:0;
        left:7.5rem;
    `
);

export const DifferentText = styled.p(
    props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.red.darkd0};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-left: ${props.theme.spacing.small.s5};
    `
);

export const RoomTypeText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const RoomImgWrap = styled.div(
    props => `
        width:28%;
        display: flex;
        jusitfy-content: flex-end;
    `
);

export const RoomImg = styled.img(
    props => `
        width:6rem;
        height: 6rem;
    `
);

export const RoomAmenitiesWrap = styled.ul(
    props => `
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.small.s8};
        padding-left: ${props.theme.spacing.base};
        list-style-type: circle;
    `
);

export const RoomAmenitieInnerWrap = styled.li(
    props => `
        display: list-item;
        align-items: center;
        padding-top: ${props.theme.spacing.small.s8};
    `
);

export const RoomAmenityText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        padding-left: ${props.theme.spacing.small.s8};
    `
);

export const GuestInfoBlock = styled.div(
    props => `
        width: 60%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: ${props.theme.spacing.large.l15};
        padding-top: ${props.noPadding ? '0' : ''};
    `
);

const Block = styled.div(
  props => `
    width: 100%;
    display: flex;
    flex-direction: row;
  `
);

export const RemoveBlock = styled(Block)(
    props => `
        justify-content: flex-end;
        padding-bottom: ${props.theme.spacing.small.s5};
        color: ${props.theme.colors.red.base};
        cursor: pointer;
    `
);

export const RemoveCircle = styled.div(
    props => `
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      background: ${props.theme.colors.red.base};
      color: ${props.theme.colors.white.base};
      padding: 0;
      text-align: center;
      line-height: 0.5;
      font-size: 2.4rem;
      font-weight: 500;
    `
);

export const GuestCountBlock = styled(Block)(
    props => `
        align-items: center;
        justify-content: center;
    `
);

export const ChildAgeBlock = styled(Block)(
    props => `
        flex-wrap: wrap;
        padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l20};
    `
);

export const GuestInfoInnerBlock = styled.div(
    props => `
        width:50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `
);

export const GuestInfoHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        padding-bottom: ${props.theme.spacing.base};
    `
);

export const GuestSelectWrap = styled.div(
    props => `
        display: flex;
        height: 3.2rem;
        width: 13rem;
        border: 1px solid ${props.theme.colors.grey.lighte7};
        border-radius: ${props.theme.misc.borderRadius.base};
    `
);

export const GuestCountText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        width: 6rem;
        text-align: center;
    `
);

export const GuestCountBtn = styled.button(
    props => `
      outline: none;
      border:none;
      background-color: ${props.theme.colors.grey.lightf2};
      height: 3rem;
      width: 3.5rem;
      align-items: center;
      justify-content: center;
      font-size: ${props.theme.font.large.font20};
      color: ${props.theme.colors.grey.base};
      border-left: 1px solid ${props.theme.colors.grey.lighte7};
      padding-bottom: ${props.theme.spacing.small.s3};
      opacity: ${props.disabled ? '0.3' : '1'};
      pointer-events: ${props.disabled ? 'none' : ''};
      cursor: ${props.disabled ? '' : 'pointer'};
    `
);

export const ChildAgeTextSpan = styled.p(
  props =>`
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
  `
);

export const ChildAgeDropdownWrapper = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
  background-color: white;
  box-shadow: 0 0px 6px 0 rgba(0,0,0,0.2);
  border-radius: ${props.theme.misc.borderRadius.base};
  height: 3.2rem;
  align-self: flex-start;
  margin-top: ${props.theme.spacing.small.s7};
  min-width: 6rem;
  `
);

export const ChildAgeValueSpan = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const ChildAgeIconWrapperSpan = styled.a(
  props => `
    display: flex;
  `
);

export const ChildDropdownWrap = styled.ul(
  props => `
  z-index: ${props.theme.misc.zIndex.small};
  overflow: scroll;
  height: 20rem;
  display:flex;
  flex-direction:column;
  position:absolute;
  margin-top: 6.5rem;
  width: 6rem;
  background: ${props.theme.colors.white.base};
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  color: ${props.theme.colors.goBrand.blue};
  overflow: scroll;
  height: 20rem;

  >li {
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    text-align:center;
    color: ${props.theme.colors.goBrand.blue};
    font-weight:bold;
    font-size: ${props.theme.font.large.font14};
    font-family: ${props.theme.font.fontFamily};
    border-bottom: 1px solid ${props.theme.colors.blue.bgBlue};
    cursor: pointer;

  &:last-child{
    border-bottom:none;
  }
`,
);

export const ChildAgeWrapperDiv = styled.div(
  props => `
    width:25%;
    display: flex;
    flex-direction: column;
    padding:${props.theme.spacing.base} 0 0 0;
  `
);
